import{mixButton as e,mixColumn as t,mixColumnNoWrap as n,mixImageWithPadding as r,mixImageWrapperFullWidth as i,mixLeftColumn as a,mixRightColumn as o,mixSectionNoWrap as s,mixSpacer as c}from"../../sections/mix-css-classes.js";import{getRegionSpacing as l}from"../get-section-padding.js";import"../../types.js";import{get as u,uniq as d}from"lodash";function f({css:e}){let t=l(e,`mix`);return`
  .${a} > table > tbody > tr > td {
    padding-top: ${Math.min(t.padding.top,24)}px!important;
  }

  .${o} > table > tbody > tr > td {
    padding-bottom: ${Math.min(t.padding.bottom,24)}px!important;
  }
  `}function p({css:e}){let r=Math.min(parseInt(u(e,`so-global-region-mix-separator.marginBottom`)||`20px`,10),20);return`
  .${t} > table > tbody > tr > td,
  .${n} > table > tbody > tr > td,
  .${a} > table > tbody > tr > td,
  .${o} > table > tbody > tr > td {
    padding: 0!important;
  }

  .${a} {
    padding-bottom: ${r}px!important;
  }

  .${c} div {
    height: ${r}px!important;
  }
  `}function m(){return`
    .${a} img,
    .${o} img {
      max-width: none !important;
      width: 100% !important;
    }
  `}function h(){return`
    .${i} {
      max-width:100%!important;
    }
    .${i} img {
      height: 100%!important;
    }
    .${t} img {
      max-width: none !important;
      width: 100% !important;
    }
    .${r} {
      width:100%!important;
      padding-right: 0!important;
      padding-left: 0!important;
    }
  `}function g({css:e}){let r=Math.min(parseInt(u(e,`so-global-region-mix-separator.marginBottom`)||`20px`,10),20);return`
    .${a},
    .${t} {
      padding-bottom: ${r}px!important;
    }

    .${s} > table > tbody > tr > td {
      padding:0px 12px!important;
    }

    .${n} > table > tbody > tr > td {
      padding: 0px 8px!important;
    }

    .${n}.${o} > table > tbody > tr > td {
      padding-bottom: ${r}px!important;
    }
    `}function _(t){let r=d(t.layout.rows[0].columns.map(({width:e})=>e||50)),i=`.${s} .${e} > table > tbody > tr > td > a {
    padding-left: 12px!important;
    padding-right: 12px!important;
  }`;return r.map(e=>`.${n}.${n}-${e} {
        width: ${e}%!important;
      }`).concat(i).join(``)}function v({css:e}){return[m(),p({css:e}),f({css:e}),g({css:e}),h()].filter(Boolean).join(` `)}function y(){return`
    .${n} {
      display: inline-block!important;
    }
  `}export{f as getHardCapMixColumnPaddingsForSmallScreenCss,p as getMixColumnPaddingsForSmallScreenCss,y as getMixCss,m as getMixImageMaxWidthForSmallScreenCss,v as getMixSmallScreenCss,g as getMobileCssForMulticolumnSetup,_ as getMobileMixMulticolumnCss,h as getSmallScreenMixImageFullWidthCss};
//# sourceMappingURL=get-mix-section-style.js.map